import { defineComponent } from '@vue/composition-api';
import __vue_component__ from './SbExperiment.vue.js';

var script = defineComponent({
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    components: {
        SbExperiment: __vue_component__,
    },
});

export default script;
